<template>
    <div>
         <p class="modal-title">
                Do you have a minute to tell us why you're leaving?
            </p>
            <div class="controls">
                <base-submit-button
                    class="btn btn-primary"
                    @click="startOffboardingSurvey"
                >
                    Sure! Ask me anything
                </base-submit-button>
                <span
                    class="cancel-link with-icon"
                    @click="suspendUser"
                >
                    No, just cancel please
                    <i
                        v-if="formProcessing"
                        class="fas fa-spinner fa-spin"
                    />
                </span>
            </div>
    </div>
</template>

<script>
import { mapMutations, mapState, mapActions } from 'vuex';
import suspendUser from '@/utils/user/suspendUser';
import toasts from '@/mixins/toasts';

export default {

    mixins: [toasts],

    data: () => ({
        formProcessing: false,
    }),

    computed: {
        ...mapState(['userSubscription']),
    },

    methods: {
        ...mapMutations(['changeUIState']),
        ...mapActions([
            'updateUser',
            'setUserMeta',
        ]),

        /**
         * Closes cancel modal
         *
         */
        closeModal() {
            this.changeUIState({ isCancelModalVisible: false });
        },

        /**
         * Starts offboarding survey
         */
        async startOffboardingSurvey() {
            await this.setUserMeta({ offboarding_started: Date.now() });
            this.$emit('next-step');
        },

        /**
         * Cancels user subscription
         */
        suspendUser() {
            suspendUser(this);
        },
    },
};
</script>
